import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../../actions/app-modal.action';
import { AppModalConstant } from '../../../../constants/app-modal.constant';
import { checkRedirection } from '../../../../actions/dnd-app.action';

class NoAccountFoundModal extends Component {

    closeModal = () => {
        this.props.closeModal()
        this.props.checkRedirection()
    }

    onClickHandler = () => {
        //logout and redirect to page
       this.closeModal()
       if(this.props.loginCallback && typeof this.props.loginCallback === "function") {
           this.props.loginCallback()
       }
    }

    render() {
        const { selectedLob } = this.props;
        return (
            <Fragment>
                <div className="modal-body">
                    <p><i class="icon-outlined-warning fs-40 color-orange"></i></p>
                    <h6 class="fs-26 mb-40 mt-10">Seems like you don’t have any {selectedLob} account added. We recommend you to login with another account.</h6>
                </div>
                <div className="modal-footer">
                    <button className="btn btn-lg btn-text" onClick={() => this.closeModal()}>{AppModalConstant.CANCEL}</button>
                    <button type="button" className="btn ng-isolate-scope" onClick={() => this.onClickHandler()} autoFocus="">
                        {AppModalConstant.LOGIN}
                    </button>
                </div>
            </Fragment>
        );
    }
}


const mapDispatchToProps = dispatch => ({
    closeModal: () => dispatch(closeModal()),
    checkRedirection: () => dispatch(checkRedirection())
})

const mapStateToProps = state => {
    return {
        selectedLob: state.ssoModalInfo.selectedLob,
        loginCallback: state.modalInfo.loginCallback
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NoAccountFoundModal);